import { cn } from "@/lib/utils";

const PALETTE = [
  "from-rose-500/30 to-red-600/20 text-rose-300",
  "from-blue-500/30 to-indigo-600/20 text-blue-300",
  "from-emerald-500/30 to-teal-600/20 text-emerald-300",
  "from-amber-500/30 to-orange-600/20 text-amber-300",
  "from-violet-500/30 to-fuchsia-600/20 text-violet-300",
  "from-cyan-500/30 to-sky-600/20 text-cyan-300",
];

const pick = (name = "") => PALETTE[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % PALETTE.length];
const initials = (name = "") =>
  name.split(/[\s-]+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

// Avatar de projeto / cliente com cor determinística.
export const ProjectAvatar = ({ name, size = "md", className }) => (
  <div
    className={cn(
      "flex items-center justify-center rounded-lg border border-white/5 bg-gradient-to-br font-heading font-bold",
      pick(name),
      size === "sm" ? "h-7 w-7 text-[11px]" : size === "lg" ? "h-12 w-12 text-base" : "h-9 w-9 text-xs",
      className,
    )}
  >
    {initials(name)}
  </div>
);

// Avatar de usuário (iniciais em vermelho de marca).
export const UserAvatar = ({ initials: ini, name, size = "md", className }) => (
  <div
    className={cn(
      "flex items-center justify-center rounded-lg bg-brand/15 font-heading font-bold text-brand ring-1 ring-brand/20",
      size === "sm" ? "h-7 w-7 text-[11px]" : size === "lg" ? "h-11 w-11 text-sm" : "h-9 w-9 text-xs",
      className,
    )}
  >
    {ini || initials(name)}
  </div>
);
